import { Ninja_Villages } from "@sisnaker-react-core/karirhub-model-type";
import { GovernmentEmployerDocumentRegistrationItem } from "./model";

export enum EmployerType {
  INDIVIDUAL = "individual",
  COMPANY = "company",
  GOVERNMENT = "government",
}

export enum EmployerStatus {
  CREATING = "creating",

  SUBMITTED = "submitted",
  IN_REVIEW = "in_review",
  REVISION_REQUESTED = "revision_requested",
  VERIFIED = "verified",
  ACTIVE = "active",
  REJECTED = "rejected",
}

export type Employer = {
  id: string;
  userId: string;
  slug: string;
  name: string;
  status: EmployerStatus;
  employerable: Company | GovernmentEmployer;
  address: string;
  postalCode: string;
  cityId: string;
  villageId: string;
  village: Ninja_Villages;
  latitude: number;
  longitude: number;
  phone: string;
  email: string;
  website: string;
  description: string;
  logoFileId: string;
  logoUri: string;
  createdAt: string;
  updatedAt: string;
  employerableId: string;
  employerableType: EmployerType;
}

export type Company = {
  cityId: string;
  cityName: string;
  countryName: string;
  createdAt: number;
  employerAverageRating: number;
  employerId: string;
  employer: {
    createdAt: string;
  };
  employerTotalRatings: number;
  id: string;
  industryId: string;
  industryName: string;
  industry: {
    id: string;
    name: string;
  };
  locations: string[];
  logoUri: string;
  name: string;
  about: string;
  phone: string;
  email: string;
  website: string;
  address: string;
  geoloc: number[];
  city: {
    id: string;
    name: string;
  };
  locationPoint: {
    latitude: number;
    longitude: number;
  };
  establishmentDate?: string;
}

export type GovernmentEmployer = {
  id: string;
  governmentAgencyId: string;
  governmentAgency: {
    id: string;
    name: string;
  };
  picName: string;
  picIdNumber: string;
  picEmail: string;
  picPhone: string;
  createdAt: string;
  updatedAt: string;
  establishmentDate?: string;

  documents: GovernmentEmployerDocumentRegistrationItem[];

  // Backward compatibility
  logoUri: string;
  about: string;
}

export type Government = {
  id: string;
  governmentAgencyId: string;
  name: string;
  governmentAgencyName: string;
  cityId: string;
  cityName: string;
  city: {
    id: string;
    name: string;
  };
  locations: string[];
  locationPoint: {
    latitude: number;
    longitude: number;
  };
  createdAt: string;
  updatedAt: string;
  establishmentDate?: string;
  employerId: string;

  documents: GovernmentEmployerDocumentRegistrationItem[];
} & GovernmentEmployer;